export default {
  itens(state) {
    return state.itens;
  }
};
